import { OrderListPage, OrderPartsPage } from 'orders/pages';
import { QuoteType } from 'quotes/enums';

import { customerOrderListPath, orderPartsPath, vendorOrderListPath } from './routePaths';

export const customerOrders = {
  path: customerOrderListPath(),
  exact: true,
  isPrivate: true,
  element: <OrderListPage key={QuoteType.CUSTOMER} type={QuoteType.CUSTOMER} />,
};

export const vendorOrders = {
  path: vendorOrderListPath(),
  exact: true,
  isPrivate: true,
  element: <OrderListPage key={QuoteType.VENDOR} type={QuoteType.VENDOR} />,
};

export const orderParts = {
  path: orderPartsPath(),
  exact: true,
  isPrivate: true,
  element: <OrderPartsPage />,
};
